"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var NumberFieldMaker_1 = __importDefault(require("containers/TableMaker/components/NumberFieldMaker"));
var InputDiscountValue = (0, NumberFieldMaker_1.default)({
    collection: 'recharged_company_vendors',
    setter: function (value, item) {
        var _a, _b, _c;
        var _d;
        return ((_d = item.planDiscount) === null || _d === void 0 ? void 0 : _d.mode) === 'percent_discount'
            ? { plansDiscountMap: (_a = {}, _a[item.id] = { value: value }, _a) }
            : { plansDiscountMap: (_b = {}, _b[item.id] = { fixedValue: (_c = {}, _c[item.currency] = value, _c) }, _b) };
    },
    getter: function (item) {
        var _a, _b, _c, _d;
        return ((_a = item.planDiscount) === null || _a === void 0 ? void 0 : _a.mode) === 'percent_discount'
            ? (_b = item.planDiscount) === null || _b === void 0 ? void 0 : _b.value
            : (_d = (_c = item.planDiscount) === null || _c === void 0 ? void 0 : _c.fixedValue) === null || _d === void 0 ? void 0 : _d[item.currency];
    },
    idGetter: function (item) { var _a; return (_a = item.rechCompVendor) === null || _a === void 0 ? void 0 : _a.id; },
    disableCondition: function (item) { var _a; return !((_a = item.planDiscount) === null || _a === void 0 ? void 0 : _a.mode); },
});
exports.default = InputDiscountValue;
